import React from 'react';

const ContactBackground = () => {
  return <div className='w-full h-full contact-background' />;
};

export default ContactBackground;
